import { Link } from "react-router-dom";
import Newsletter from "./Newsletter";

const CATS = [
  { slug: "investing", name: "Investing" },
  { slug: "personal-finance", name: "Personal Finance" },
  { slug: "cryptocurrency", name: "Cryptocurrency" },
  { slug: "stock-market", name: "Stock Market" },
  { slug: "retirement-planning", name: "Retirement Planning" },
  { slug: "market-analysis", name: "Market Analysis" },
];

export default function Footer() {
  return (
    <footer className="mt-24 border-t-2 border-foreground/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="font-display font-black text-3xl tracking-tight">
            Finance Topia
          </div>
          <p className="mt-3 text-sm text-foreground/70 max-w-md leading-relaxed">
            Independent, editorial-grade finance journalism. Fact-based analysis of
            markets, investing, and personal finance — written for beginners and
            reviewed by CFA-trained analysts.
          </p>
          <div className="mt-6">
            <Newsletter compact />
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-4">Categories</div>
          <ul className="space-y-2 text-sm">
            {CATS.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/category/${c.slug}`}
                  data-testid={`footer-cat-${c.slug}`}
                  className="hover:text-primary transition-colors duration-200"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-4">Publication</div>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-tools" to="/tools" className="hover:text-primary transition-colors duration-200">Tools</Link></li>
            <li><Link data-testid="footer-about" to="/about" className="hover:text-primary transition-colors duration-200">About</Link></li>
            <li><Link data-testid="footer-editorial" to="/editorial" className="hover:text-primary transition-colors duration-200">Editorial Team</Link></li>
            <li><Link data-testid="footer-contact" to="/contact" className="hover:text-primary transition-colors duration-200">Contact</Link></li>
            <li><Link data-testid="footer-privacy" to="/privacy" className="hover:text-primary transition-colors duration-200">Privacy</Link></li>
            <li><Link data-testid="footer-terms" to="/terms" className="hover:text-primary transition-colors duration-200">Terms</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-4">Follow</div>
          <ul className="space-y-2 text-sm">
            <li><a href="https://twitter.com" className="hover:text-primary transition-colors duration-200">Twitter / X</a></li>
            <li><a href="https://linkedin.com" className="hover:text-primary transition-colors duration-200">LinkedIn</a></li>
            <li><a href="/api/sitemap.xml" className="hover:text-primary transition-colors duration-200">Sitemap</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-foreground/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="text-xs text-foreground/60 font-mono">
            © {new Date().getFullYear()} Finance Topia. All rights reserved.
          </div>
          <div className="text-xs text-foreground/50 font-mono">
            Editorial content. Not investment advice.
          </div>
        </div>
      </div>
    </footer>
  );
}
